export function getColor(defaultColor: string = "0, 0, 0, 1", color: string, blackColor: boolean): string {
  if (blackColor) {
    return "rgba(0, 0, 0, 1)"; // blackColor prop
  }
  return color ? `rgba(${color})` : `rgba(${defaultColor})`;
}

export function lightenRgbColor(rgba: string, percent: number): string {
  if (!rgba) return "255, 255, 0, 1";
  const parts = rgba.split(",").map((c) => parseFloat(c.trim()));
  const [r, g, b] = parts;
  const a = parts.length > 3 ? parts[3] : 1;
  const p = percent / 100;
  const newR = Math.round(r + (255 - r) * p);
  const newG = Math.round(g + (255 - g) * p);
  const newB = Math.round(b + (255 - b) * p);
  return `${newR}, ${newG}, ${newB}, ${a}`;
}

export function darkenRgbColor(rgba: string, percent: number): string {
  if (!rgba) return "255, 255, 0, 1";
  const parts = rgba.split(",").map((c) => parseFloat(c.trim()));
  const [r, g, b] = parts;
  const a = parts.length > 3 ? parts[3] : 1;
  const p = percent / 100;
  const newR = Math.round(r - (255 - r) * p);
  const newG = Math.round(g - (255 - g) * p);
  const newB = Math.round(b - (255 - b) * p);
  return `${newR}, ${newG}, ${newB}, ${a}`;
}
